<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        External Data
        <icon-tooltip icon="informationOutline"
                      text="Your API-Endpoint URL - GET Method. It must return an Array. Read more on Documentation"/>
      </label>

      <v-autocomplete
          v-model="selectedItem"
          :items="external_data_items"
          item-text="name"
          item-value="id"
          label="Define External Data"
          single-line
          return-object
          :class="styles.FORM.FORM_CONTROL"
          @change="loadDataItems()"
          dense
      />
    </div>
    <div v-if="external_data_headers.length > 0">
      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Value Key of your Object
          <icon-tooltip icon="informationOutline"
                        text="[{'value': '',...}] => value"/>
        </label>

        <v-autocomplete
            :class="styles.FORM.FORM_CONTROL"
            v-model="control.field_text"
            :items="external_data_headers"
            :rules="externalDataFieldRules"
            label="Define the Key of the object"
            single-line
            dense
        />
      </div>

      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Text Value of your Object
          <icon-tooltip icon="informationOutline"
                        text="[{'text': '',...}] => text"/>
        </label>

        <v-autocomplete
            :class="styles.FORM.FORM_CONTROL"
            :items="external_data_headers"
            v-model="control.field_value"
            :rules="externalDataFieldRules"
            label="Define the value of the object"
            single-line
            dense
        />
      </div>



      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Hint value of the object
          <icon-tooltip icon="informationOutline"
                        text="[{'text': '',...}] => text"/>
        </label>

        <v-select
            :class="styles.FORM.FORM_CONTROL"
            :items="external_data_headers"
            v-model="control.field_hint"
            :rules="externalDataFieldRules"
            label="Define the value of the hint object"
            single-line
        />
      </div>
    </div>
  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';
import {readAdminExternalDataList} from '@/store/admin/getters';
import {dispatchGetExternalDataListAdmin} from '@/store/admin/actions';
import {rules} from '@/utils';


export default {
  name: 'DropdownConfigView',
  extends: BaseControlConfigSkeleton,
  data: () => ({
    selectedItem: null,
    external_data_items: [],
    external_data_headers: [],
    rules,
  }),

  computed: {
    isExternalDataSelected() {
      return Number(this.control.external_data_id) > 0;
    },

    externalDataFieldRules() {
      return this.isExternalDataSelected ? this.rules.required : [];
    },
  },

  methods: {

    loadDataItems() {
      if (this.selectedItem) {
        this.control.external_data_id = this.selectedItem.id;
        this.external_data_headers = Array.isArray(this.selectedItem.headers) ? this.selectedItem.headers : [];
        this.ensureExternalDataFields();
      } else {
        this.control.external_data_id = 0;
        this.external_data_headers = [];
      }
    },

    ensureExternalDataFields() {
      ['field_text', 'field_value', 'field_hint'].forEach((fieldName) => {
        if (!this.external_data_headers.includes(this.control[fieldName])) {
          this.$set(this.control, fieldName, null);
        }
      });
    },

  },

  async mounted() {
    await dispatchGetExternalDataListAdmin(this.$store);
    this.external_data_items = await readAdminExternalDataList(this.$store);
    if (this.control.external_data_id > 0) {
      this.selectedItem = this.external_data_items.filter((e) => e.id === this.control.external_data_id)[0];
      this.loadDataItems();
    }
  },
};
</script>

<style scoped>

</style>
